module.exports = __webpack_public_path__ + "static/media/storj.c952db66.svg";